import { Link } from "react-router-dom";

interface NovelCardProps {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  rating: number;
  status: string;
  tags: string[];
}

export default function NovelCard({ id, title, author, coverImage, description, rating, status, tags }: NovelCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
    >
      <div className="aspect-[2/3] overflow-hidden relative bg-background-100">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2 px-2 py-0.5 text-xs rounded-full bg-background-50/90 text-foreground-700 font-medium">
          {status}
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 mt-1">{author} 著</p>
        <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
          {description}
        </p>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-sm font-medium text-foreground-700">{rating}</span>
          </div>
          <div className="flex gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}